
export const toSafeJS = (object) => {
	if (!!object && typeof object.toJS === 'function') {
		return object.toJS();
	}
	return object;
};
